module.exports = __webpack_public_path__ + "img/sus_main_bg.7a9244e1.jpg";